import React from 'react';
import Container from '@hpstellar/core/Container'

import AboveTheFoldOnlyServerRender from '../../../shared/components/above-the-fold-only-server-render';
import withPageComponents from '../../../page/components/with-page-components';

import { FeaturesMapper } from '../../components/tabs/features';

const pdpOverview = ({ pdpFeatures }) => {
    if (pdpFeatures) {
        const { featuresContent } = pdpFeatures;
        if (featuresContent) {
            return (<div className={'pdp-rich-content'}>
                <AboveTheFoldOnlyServerRender skip={true} offset={1000} >
                    <Container>
                        <FeaturesMapper features={pdpFeatures} />
                    </Container>
                </AboveTheFoldOnlyServerRender>
            </div>);
        }

    }
    return null;
}

export default withPageComponents(pdpOverview, { components: ['pdpFeatures'] })
